<div class="flex justify-center items-center p-4 w-full min-h-full register-page">
  <div class="flex flex-col items-stretch register-page__inner">
    <!-- Card form  -->
    <div class="bg-white shadow-2xl rounded-lg w-full">
      <div class="card--auth">
            <!-- Title header like screenshot -->
            <div class="mb-4 register-header">
              <h2 class="register-title">
                {{ otpStage() ? 'Conferma OTP' : 'Crea un account' }}
              </h2>
              <p class="register-sub">
                {{ otpStage() ? '' : 'Inserisci i tuoi dati' }}
              </p>
            </div>

            <form [formGroup]="formRegister" class="register-form">
              <div class="form-content">
                @if (!otpStage()) {
                  <div class="gap-4 grid grid-cols-1 md:grid-cols-2">

                    <!-- Email o PEC - Full width -->
                    <div class="relative col-span-full mb-2">
                      <dpac-input-field
                        formControlName="email"
                        [type]="'email'"
                        [label]="'E-mail o PEC'"
                        [placeholder]="'nome@dominio.it'"
                        [autocomplete]="'email'"
                        [required]="true"
                        [readonly]="emailLocked()"
                      ></dpac-input-field>
                      @if (emailLocked()) {
                        <div class="mt-1 text-gray-500 text-sm">
                          Email associata al tuo account.
                        </div>
                      }
                      @if (formRegister.get('email')?.invalid && formRegister.get('email')?.touched) {
                        <div class="-bottom-4 left-0 absolute text-red-500 text-xs">Inserisci un'email o PEC valida</div>
                      }
                    </div>

                    <!-- Nome - Half width -->
                    <div class="relative mb-2">
                      <dpac-input-field
                        formControlName="nome"
                        [label]="'Nome'"
                        [placeholder]="'Mario'"
                        [required]="true"
                      ></dpac-input-field>
                      @if (formRegister.get('nome')?.invalid && formRegister.get('nome')?.touched) {
                        <div class="-bottom-4 left-0 absolute text-red-500 text-xs">Nome è obbligatorio</div>
                      }
                    </div>

                    <!-- Cognome - Half width -->
                    <div class="relative mb-2">
                      <dpac-input-field
                        formControlName="cognome"
                        [label]="'Cognome'"
                        [placeholder]="'Rossi'"
                        [required]="true"
                      ></dpac-input-field>
                      @if (formRegister.get('cognome')?.invalid && formRegister.get('cognome')?.touched) {
                        <div class="-bottom-4 left-0 absolute text-red-500 text-xs">Cognome è obbligatorio</div>
                      }
                    </div>

                    <!-- Ente -->
                    <div class="relative mb-2">
                      <dpac-select
                        formControlName="ente"
                        [label]="'Ente'"
                        [placeholder]="'Cerca ente...'"
                        [required]="true"
                        [options]="enteOptions()"
                        [optionLabel]="'nominativo'"
                        [optionValue]="'id'"
                        [search]="true"
                        [lazy]="true"
                        (searchChange)="onEnteSearch($event)"
                        [loading]="enteLoading()"
                        [showChips]="false"
                        [multiple]="false"
                      ></dpac-select>
                      @if (formRegister.get('ente')?.invalid && formRegister.get('ente')?.touched) {
                        <div class="mt-1 text-red-500 text-xs">Seleziona un ente dalla lista</div>
                      }
                      <button type="button" class="text-indigo-600 text-sm hover:underline register-ente-link" (click)="openNuovoEnte()">
                        L'ente non è in elenco? Inserisci un nuovo ente
                      </button>
                    </div>

                    <!-- Ruolo - Half width -->
                    <div class="relative mb-2">
                      <dpac-input-field
                        formControlName="ruolo"
                        [label]="'Ruolo'"
                        [placeholder]="'Inserisci ruolo'"
                        [required]="true"
                      ></dpac-input-field>
                      @if (formRegister.get('ruolo')?.invalid && formRegister.get('ruolo')?.touched) {
                        <div class="left-0 absolute text-red-500 text-xs">Ruolo è obbligatorio</div>
                      }
                    </div>

                    <!-- Privacy Checkbox - Full width -->
                    <div class="col-span-full bg-gray-50 mt-4 p-4 rounded-sm privacy-container">
                      <dpac-checkbox
                        formControlName="privacy"
                        [error]="!!(formRegister.get('privacy')?.invalid && formRegister.get('privacy')?.touched)"
                      >
                        Dichiaro di aver letto e compreso l'
                        <a
                          routerLink="/privacy-policy"
                          class="register-privacy-link"
                          (click)="$event.stopPropagation()"
                        >informativa sulla privacy</a>
                        e acconsento al trattamento dei miei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR).
                      </dpac-checkbox>
                    </div>
                  </div>
                }

                <!-- OTP stage -->
                @if (otpStage()) {
                  <div class="gap-4 grid grid-cols-1">
                    <div>
                      <dpac-input-field
                        formControlName="otp"
                        [label]="'Codice OTP'"
                        [placeholder]="'Inserisci il codice ricevuto via email'"
                        [required]="true"
                      ></dpac-input-field>
                      <div class="mt-1 text-gray-500 text-sm">
                        Inserisci il codice OTP che ti abbiamo inviato per confermare la registrazione.
                      </div>
                    </div>
                  </div>
                }
              </div>

              <!-- Buttons -->
              <div class="register-actions">
                <!-- Indietro -->
                <dpac-button
                  (onClick)="goBack()"
                  [label]="'Indietro'"
                  classe="custom-button-md shadow-sm">
                </dpac-button>

                @if (!otpStage()) {
                  <!-- Conferma Registrazione -->
                  <dpac-button
                    classe="custom-button-md primary shadow-sm"
                    (onClick)="register()"
                    [label]="'Conferma'"
                    [disabled]="formRegister.invalid"
                    >
                  </dpac-button>
                } @else {
                  <!-- Rinvia OTP -->
                  <dpac-button
                    (onClick)="requestOtp()"
                    classe="custom-button-md shadow-sm"
                    [label]="'Rinvia OTP'">
                  </dpac-button>
                  <!-- Verifica OTP -->
                  <dpac-button
                    (onClick)="verifyOtp()"
                    classe="custom-button-md primary shadow-sm"
                    [label]="'Verifica OTP'"
                    [disabled]="!formRegister.get('otp')?.valid">
                  </dpac-button>
                }
              </div>
            </form>
      </div>
    </div>
  </div>
</div>
